import React, { ReactNode } from "react";

interface AlertProps {
  icon?: ReactNode;
  children: ReactNode;
  className?: string;
  variant?: "warning" | "info" | "error" | "success";
}

const Alert: React.FC<AlertProps> = ({
  icon,
  children,
  className = "",
  variant = "warning",
}) => {
  const getVariantClass = () => {
    switch (variant) {
      case "warning":
        return "bg-turquoise-dark text-white";
      case "info":
        return "bg-blue-100 text-blue-800";
      case "error":
        return "bg-red-100 text-red-800";
      case "success":
        return "bg-green-100 text-green-800";
      default:
        return "bg-turquoise-dark text-white";
    }
  };

  return (
    <div
      className={`p-3 rounded flex gap-4 items-center ${getVariantClass()} ${className}`}
    >
      {icon && icon}
      {typeof children === "string" ? <span>{children}</span> : children}
    </div>
  );
};

export default Alert;
